// Prev/Next bill control, shared by the View Billing sheet and the Edit Bill
// screen so both read and behave identically. Pure presentation — the stepping
// logic lives in useBillNavigation.
import * as React from "react";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { Button } from "ui/button";
import type { BillNavigation } from "./useBillNavigation";

export interface BillNavigatorProps extends Pick<BillNavigation, "hasPrev" | "hasNext" | "goPrev" | "goNext" | "isPending"> {
    className?: string;
}

export function BillNavigator({
    hasPrev,
    hasNext,
    goPrev,
    goNext,
    isPending,
    className,
}: BillNavigatorProps) {
    // Nothing to step through (single result, or the bill isn't in the loaded
    // list at all) — render nothing rather than dead controls.
    if (!hasPrev && !hasNext && !isPending) return null;
    return (
        <div className={className ? `flex items-center gap-2 ${className}` : "flex items-center gap-2"}>
            <Button
                variant="default"
                size="sm"
                className="h-8 px-3 shadow-sm"
                aria-label="Previous bill"
                title="Previous bill"
                disabled={!hasPrev}
                onClick={goPrev}
            >
                {isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <ChevronLeft className="h-4 w-4" />}
                Previous
            </Button>
            <Button
                variant="default"
                size="sm"
                className="h-8 px-3 shadow-sm"
                aria-label="Next bill"
                title="Next bill"
                disabled={!hasNext}
                onClick={goNext}
            >
                 {isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <ChevronRight className="h-4 w-4" />}
                Next
            </Button>
        </div>
    );
}

export default BillNavigator;
